'use client';

import * as React from 'react';
import { LocaleProvider as SharedLocaleProvider, useLocaleCtx } from '~shared/config/contexts/LocaleProvider';
import { useResolvedCompanyCtx } from '../ResolvedCompanyContext/ResolvedCompanyProvider';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Wrapper for currently resolved/selected language locale provider.
 * Depends on ResolvedCompanyProvider, ensures that the company is resolved.
 */
export var LocaleProvider = function LocaleProvider(_ref) {
  var children = _ref.children;
  var resolvedCompanyContext = useResolvedCompanyCtx();

  if (!resolvedCompanyContext) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }

  var locale = resolvedCompanyContext.selectedLanguage.code;
  return /*#__PURE__*/_jsx(SharedLocaleProvider, {
    locale: locale,
    children: children
  });
};
export { useLocaleCtx };